import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../../../axios';

/**
 * Szkic wiadomości z AI.
 *
 * Korzystamy z istniejącego `v3-generateAIContent`, tego samego, którym panel generuje
 * opisy: endpoint zwraca tytuł i treść, a układ bloków składamy po naszej stronie. Dzięki
 * temu funkcja działa bez dokładania nowej chmury i bez wdrożenia backendu. Gdy AI ma
 * dobierać także bloki (lista, przycisk, sekcje), trzeba będzie osobnego endpointu
 * zwracającego nasz JSON.
 */

export interface TemplateDraftRequest {
  /** Polecenie użytkownika, np. „poinformuj o przerwie technicznej w sobotę". */
  context: string;
  tone: string;
  toneLabel: string;
  /** Długość treści w słowach, w granicach przyjmowanych przez endpoint. */
  descriptionLength: number;
}

export interface TemplateDraft {
  title: string;
  description: string;
}

export const useGenerateTemplateDraft = (): UseMutationResult<
  TemplateDraft,
  AxiosError,
  TemplateDraftRequest
> => useMutation<TemplateDraft, AxiosError, TemplateDraftRequest>({
  mutationFn: async (request) => {
    const res = await axiosInstance.post<TemplateDraft>('/v3-generateAIContent', {
      context: request.context,
      mode: 'basic',
      usageContext: 'wiadomość e-mail od hotelspot do administratorów hotelu korzystających z panelu',
      category: 'inmail',
      categoryLabel: 'Wiadomość do klientów panelu',
      tone: request.tone,
      toneLabel: request.toneLabel,
      descriptionLength: request.descriptionLength,
      includeEmojis: false,
      baseLang: 'pl',
    }, { headers: { 'Content-Type': 'application/json' }, timeout: 120_000 });
    return res.data;
  },
});
